import { css } from "@emotion/core";
import { mq } from "../../cssInJs";

export default {
  top: css(
    mq({
      height: [44, null, 110],
      background: "white",
      position: "fixed",
      width: "100%",
      zIndex: "999",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      transition: "all 0.3s",
      boxShadow: "0 2px 10px 0 rgba(36,50,66,.075)",
    })
  ),
  topScrolled: css(
    mq({
      height: [44, null, 74],
    })
  ),
  navBox: css(
    mq({
      position: "fixed",
      right: "60px",
    })
  ),
  logo: css(mq({})),
  logoImg: css(
    mq({
      display: "block",
      height: [30, null, 50],
    })
  ),
  logoImgScolled: css(
    mq({
      transition: "all 0.3s",
      display: "block",
      height: [30, null, 40],
    })
  ),
};
